import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import { TextField, Button, Grid } from '@mui/material';
import { updateUserCredentials } from 'services/userProfile.services';
import AlertBox from 'views/Common/AlertBox';
import history from '../../router/history';
import routes from '../../constants/Routes';
import { Backdrop, CircularProgress } from '@mui/material';
import theme from 'theme';
import { useNavigate } from 'react-router-dom';

const PREFIX = 'ResetPassword';

const classes = {
    root: `${PREFIX}-root`,
    backdrop: `${PREFIX}-backdrop`,
    maxWidthSize: `${PREFIX}-maxWidthSize`,
    formControl: `${PREFIX}-formControl`,
    selectEmpty: `${PREFIX}-selectEmpty`,
    textInput: `${PREFIX}-textInput`,
    textInputLabel: `${PREFIX}-textInputLabel`,
    tr: `${PREFIX}-tr`,
    uploadInput: `${PREFIX}-uploadInput`
};

const Root = styled('div')((
    {
        theme: Theme
    }
) => ({
    [`& .${classes.root}`]: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
        display: 'flex',
        //   height: 224,
    },

    [`& .${classes.backdrop}`]: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },

    [`& .${classes.maxWidthSize}`]: {
        width: '40%',
    },

    [`& .${classes.formControl}`]: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        minWidth: 120,
        textAlign: 'left',
    },

    [`& .${classes.selectEmpty}`]: {},

    [`& .${classes.textInput}`]: {
        height: 50,
    },

    [`& .${classes.textInputLabel}`]: {
        fontSize: '1rem',
        lineHeight: 1,
    },

    [`& .${classes.tr}`]: {
        background: '#f1f1f1',
        '&:hover': {
            background: '#f00',
        },
    },

    [`& .${classes.uploadInput}`]: {
        display: 'none',
    }
}));

const ResetPassword = () => {
  const navigate = useNavigate()

	const [currentPassword, setCurrentPassword] = useState('');
	const [newPassword, setNewPassword] = useState('');
	const [confirmPassword, setConfirmPassword] = useState('');
	const [snackbarMessage, setSnackbarMessage] = useState('');
	const [alertCurentPassword, setAlertCurentPassword] = useState(false);
	const [alertMismatchPassword, setAlertMismatchPassword] = useState(false);
	const [progress, setProgress] = React.useState(false);
	const [alertError, setAlertError] = useState({ message: '', open: false, type: '' });

	const handleOnChange = (event: any) => {
		const name: string = event.target.name;
		const value: any = event.target.value;

		switch (name) {
			case 'oldPassword':
				setCurrentPassword(value);
				break;
			case 'newPassword':
				setNewPassword(value);
				break;
			case 'confirmPassword':
				setConfirmPassword(value);
				break;
			default:
				break;
		}
	};

	const handleUserCredentials = () => {
		const userCred = {
			password: newPassword,
			confirmPassword: confirmPassword,
			currentPassword: currentPassword,
		};
		UpdateCredentialsDetails(userCred);
	};

	const UpdateCredentialsDetails = async (input: any) => {
		const { id, ...newInput } = input;
		setProgress(true);
		try {
			await updateUserCredentials(newInput);
			const alert = {
				message: 'Updated Successfully',
				open: true,
				type: 'success',
			};
			setProgress(false);
			setAlertError(alert);
			setTimeout(() => {
				const alert = {
					message: '',
					open: false,
					type: '',
				};
				setAlertError(alert);
        navigate(routes.LOGIN.path);
			}, 2000);
		} catch (error) {
			const alert = {
				message: 'Update Failed',
				open: true,
				type: 'Warning',
			};
			setProgress(false);
			setAlertError(alert);
		}
	};

	const handleUpdateUserCredentials = () => {
		if (currentPassword.length !== 0) {
			if (newPassword.length !== 0) {
				if (newPassword === confirmPassword) {
					setAlertMismatchPassword(false);
					handleUserCredentials();
				} else {
					setSnackbarMessage('Password does not match');
					handleClick('mismatch password');
				}
			} else {
				setSnackbarMessage('Enter Password');
				handleClick('empty new password');
			}
		} else {
			setSnackbarMessage('Enter Password');
			handleClick('empty password');
		}
		return null;
	};

	const handleClick = (input: string) => {
		switch (input) {
			case 'wrong password':
				setAlertCurentPassword(true);
				break;
			case 'mismatch password':
				setAlertCurentPassword(false);
				setAlertMismatchPassword(true);
				break;
			case 'empty password':
				setAlertCurentPassword(true);
				break;
			case 'empty new password':
				setAlertCurentPassword(false);
				setAlertMismatchPassword(true);
				break;
			default:
				break;
		}
	};

	return (
        <Root>
			<Backdrop className={classes.backdrop} open={progress}>
				<CircularProgress color="inherit" />
			</Backdrop>
			<AlertBox
				message={alertError.message}
				shouldOpen={alertError.open}
				type={alertError.type}
			/>
			<Grid container style={{ textAlign: 'center' }}>
				<Grid item xs={12}>
					<h5 style={{ marginTop: '12%' }}>UPDATE PASSWORD</h5>
					<TextField
						error={alertCurentPassword}
						helperText={alertCurentPassword ? snackbarMessage : null}
						value={currentPassword}
						onChange={handleOnChange}
						className={classes.maxWidthSize}
						variant="outlined"
						margin="normal"
						type="password"
						required
						fullWidth
						autoComplete="off"
						name="oldPassword"
						label="Old Password"
					/>
				</Grid>

				<Grid item xs={12}>
					<TextField
						error={alertMismatchPassword}
						helperText={alertMismatchPassword ? snackbarMessage : null}
						value={newPassword}
						onChange={handleOnChange}
						className={classes.maxWidthSize}
						variant="outlined"
						margin="normal"
						required
						fullWidth
						autoComplete="off"
						name="newPassword"
						label="New Password"
						type="password"
						id="password"
					/>
				</Grid>
				<Grid item xs={12}>
					<TextField
						error={alertMismatchPassword}
						helperText={alertMismatchPassword ? snackbarMessage : null}
						value={confirmPassword}
						onChange={handleOnChange}
						className={classes.maxWidthSize}
						variant="outlined"
						margin="normal"
						required
						fullWidth
						autoComplete="off"
						name="confirmPassword"
						label="Confirm Password"
						type="password"
						id="confirmPassword"
					/>
				</Grid>
				<Grid item xs={12}>
					<div style={{ textAlign: 'center' }}>
						<Button
							variant="contained"
							color="primary"
							onClick={handleUpdateUserCredentials}
							style={{ textAlign: 'center' }}>
							SAVE
						</Button>
					</div>
				</Grid>
			</Grid>
		</Root>
    );
};

export default ResetPassword;
